// utils
import { _val } from 'app/utils';
import { applySuggestScheduling } from 'app/components/modals/pad-editor/prescriptionModal/prescriptionForms/utils/applySuggestScheduling';

export const prescriptionProcedureInitFormFn = (values = {}) => {
  values = applySuggestScheduling(values);

  return {
    calendarType: _val(values.calendarType, null),
    frequencyAmount: _val(values.frequencyAmount, null),
    frequencyTypeId: _val(values.frequencyTypeId, null),
    suggestScheduling: _val(values.suggestScheduling, null),

    firstApplicationDate: _val(values.firstApplicationDate, null),
    firstApplicationTime: _val(values.firstApplicationTime, null),

    scheduleType: _val(values.scheduleType, null),
    perDayPerShifts: _val(values.perDayPerShifts, []),
    perWeekPerShift: _val(values.perWeekPerShift, null),

    perWeekSpecificTime: _val(values.perWeekSpecificTime, null),
    perMonthPerShift: _val(values.perMonthPerShift, null),
    perMonthPerShiftDates: _val(values.perMonthPerShiftDates, []),
    perMonthSpecificTime: _val(values.perMonthSpecificTime, null),
    perMonthSpecificTimeDates: _val(values.perMonthSpecificTimeDates, []),
    applicationTimes: _val(values.applicationTimes, []),

    padPrescriptionMatMeds: _val(values.padPrescriptionMatMeds, []),

    daysOfWeek: _val(values.daysOfWeek, []),
    dose: _val(values.dose, null),
    administrationRouteId: _val(values.administrationRouteId, null),
    diluentDose: _val(values.diluentDose, null),
    diluentId: _val(values.diluentId, null),
    asNeeded: _val(values.asNeeded, null),
    continuousUse: _val(values.continuousUse, 1),
    period: _val(values.period, null),
    justification: _val(values.justification, null),
    instruction: _val(values.instruction, null),

    alertMessageFrequency: _val(values.alertMessageFrequency, {}),

    // professional prescriptor
    professionalId: _val(values.professionalId, null),
    responsibleForPrescription: _val(values.responsibleForPrescription, {}),
    alertMessage: _val(values.alertMessage, {}),

    formAddOn: {
      diluent: _val(values.diluent, {}),
      frequencyType: _val(values.frequencyType, {}),
      professional: _val(values.professional, {})
    }
  };
};
